let featuredContent = [
    {id: 1, imgUrl: "/images/Products/featured-1.png", title: "Beats Solo 2 On Ear Headphones - Black", price: 499, offPrice: 599,},
    {id: 1, imgUrl: "/images/Products/featured-2.png", title: "H-Squared tvTray", price: 399, offPrice: 499,},
    {id: 1, imgUrl: "/images/Products/featured-3.png", title: "Netatmo Rain Gauge", price: 299, offPrice: 399,},
]

export default featuredContent